import * as zod from 'zod'

export const categorySchema = zod.object({
  positionTemplateId: zod.number({
    required_error: 'Position is required',
  }),
})

export type CategoryForm = zod.infer<typeof categorySchema>
